import { TemplateResult, html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { AdoptedStyleSheets } from '../../controllers/adopted-stylesheets';
import encapsulatedStyles from './styles/outline-ratings-summary.inner.pcss?inline';
import globalStyles from './styles/outline-ratings-summary.global.pcss?inline';

/**
 * The OutlineRatingsSummary component
 * @element outline-ratings-summary
 */
@customElement('outline-ratings-summary')
export class OutlineRatingsSummary extends LitElement {
  adoptedStyleSheets = new AdoptedStyleSheets(this, {
    encapsulatedCSS: encapsulatedStyles,
    globalCSS: globalStyles,
  });

  @property({ type: String, reflect: true, attribute: 'variant' })
  variant: 'hero' | 'default' = 'default';

  render(): TemplateResult {
    return html`
      <div class="outline-ratings-summary">
        <slot name="heading"></slot>

        <slot name="summary"></slot>
      </div>
    `;
  }
}

// Declare the custom element for TypeScript
declare global {
  interface HTMLElementTagNameMap {
    'outline-ratings-summary': OutlineRatingsSummary;
  }
}
